import React, { createContext, Dispatch, ReactNode, SetStateAction, useContext, useEffect, useState } from 'react';
import { PurchaseOrderContractTask } from '@/hooks/api/models';

type Props = {
  children: ReactNode;
};

export type PurchaseOrderContractTaskContextType = {
  purchaseOrderContractTask?: PurchaseOrderContractTask;
  setPurchaseOrderContractTask: Dispatch<SetStateAction<PurchaseOrderContractTask | undefined>>;
};

export const PurchaseOrderContractTaskContext = createContext<PurchaseOrderContractTaskContextType>({
  purchaseOrderContractTask: undefined,
  setPurchaseOrderContractTask: () => {},
});

export const PurchaseOrderContractTaskProvider = ({ children }: Props) => {
  const [purchaseOrderContractTask, setPurchaseOrderContractTask] = useState<PurchaseOrderContractTask>();

  return (
    <PurchaseOrderContractTaskContext.Provider value={{ purchaseOrderContractTask, setPurchaseOrderContractTask }}>
      {children}
    </PurchaseOrderContractTaskContext.Provider>
  );
};

export const useCurrentPurchaseOrderContractTask = () => {
  return useContext(PurchaseOrderContractTaskContext);
};
